import { AssessmentContainer } from "./components/AssessmentContainer";

export function SNSEAssessment() {
  return <AssessmentContainer definitionId="snse" taskType="COMPLETE_SNSE_ASSESSMENT" />;
}
